module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Also by Erica Spindler")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Breakneck"), _c('br'), _vm._v("Last Known Victim"), _c('br'), _vm._v("Copycat"), _c('br'), _vm._v("Killer Takes All"), _c('br'), _vm._v("See Jane Die"), _c('br'), _vm._v("In Silence"), _c('br'), _vm._v("Dead Run"), _c('br'), _vm._v("Bone Cold"), _c('br'), _vm._v("All Fall Down"), _c('br'), _vm._v("Cause for Alarm"), _c('br'), _vm._v("Shocking Pink"), _c('br'), _vm._v("Fortune"), _c('br'), _vm._v("Forbidden Fruit"), _c('br'), _vm._v("Red")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609f9010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0